export default function StepProgressBar({ steps, current }) {
  return (
    <div style={{ display: 'flex', padding: '14px 28px 0', gap: 0 }}>
      {steps.map((s, i) => {
        const done   = i < current;
        const active = i === current;
        const color  = done || active ? 'var(--gold)' : 'rgba(255,255,255,.2)';
        return (
          <div key={s} style={{ flex: 1, textAlign: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {i > 0 && (
                <div style={{
                  flex: 1, height: 1,
                  background: done ? 'var(--gold)' : 'rgba(255,255,255,.12)',
                  transition: 'background .3s',
                }} />
              )}
              <div style={{
                width: 26, height: 26, borderRadius: '50%', flexShrink: 0,
                border: `2px solid ${color}`,
                background: active ? 'var(--gold)' : done ? 'rgba(201,168,76,.2)' : 'transparent',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: active ? '#000' : color,
                fontSize: 11, fontWeight: 700,
                transition: 'all .3s',
              }}>
                {done ? '✓' : i + 1}
              </div>
              {i < steps.length - 1 && (
                <div style={{
                  flex: 1, height: 1,
                  background: done ? 'var(--gold)' : 'rgba(255,255,255,.12)',
                  transition: 'background .3s',
                }} />
              )}
            </div>
            <div style={{
              fontSize: 9, color, marginTop: 5,
              letterSpacing: '.06em', textTransform: 'uppercase',
              fontWeight: active ? 700 : 400,
              transition: 'color .3s',
            }}>
              {s}
            </div>
          </div>
        );
      })}
    </div>
  );
}
